import { render, staticRenderFns } from "./ContactSubHeader.vue?vue&type=template&id=6451e1bc"
import script from "./ContactSubHeader.vue?vue&type=script&lang=js"
export * from "./ContactSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports